export const formatPrice = (val, curr) => {
  if (!curr) {
    const userPrefs = JSON.parse(localStorage.getItem("user-prefsv2"));
    curr = userPrefs?.currency?.code || "USD";
  }
  if (!val) val = 0;
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: curr,
  }).format(val / 100);
};
